import {NgForOf} from '@angular/common';
import {NgModule} from '@angular/core';
import {
    ValueWithDelDisplayDecimalPipe
} from '../../components/bigint-display-decimal-pipe/value-with-del-display-decimal.pipe';
import {CopyTooltipModule} from '../../components/copy-tooltip/copy-tooltip.module';
import {CopyTxExploreTooltipModule} from '../../components/copy-tx-explore-tooltip/copy-tx-explore-tooltip.module';
import {CustomScrollbarModule} from '../../components/custom-scrollbar';
import {WalletAvatarComponent} from '../../components/dex/wallet-avatar/wallet-avatar.component';
import {DisplayDecimalModule} from '../../components/display-decimal';
import {ShortenWalletAddrPipe} from '../../components/dynamic-xyz/utils/shorten-wallet-addr.pipe';
import {ElementRulerModule} from '../../components/element-ruler';
import {FlashMessageModule} from '../../components/flash-message';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {MultiselectSearchInputModule} from '../../components/search-fields/multiselect-search-input';
import {TextSearchInputModule} from '../../components/search-fields/text-search-input/text-search-input.module';
import {TablePaginationModule} from '../../components/table-pagination';
import {TablesModule} from '../../components/tables';
import {TooltipModule} from '../../components/tooltip';
import {L10nModule} from '../../components/translate';
import {TextHidingModule} from '../../directives/text-hiding';
import {BackofficeUserSessionService} from '../../services/backoffice-user-session.service';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {RefreshButtonModule} from '../components/widget-filter/refresh-button';
import {DexTxHistoryWContentComponent} from './dex-tx-history-w-content.component';
import {DexTxHistoryWidgetComponent} from './dex-tx-history-widget.component';
import {DEX_TX_HISTORY_WIDGET_DESCRIPTION} from './dex-tx-history-widget.description';
import {DexTxHistoryWidgetSettingsComponent} from './settings/dex-tx-history-widget-settings.component';
import {DexTxHistoryWidgetSettingsService} from './settings/dex-tx-history-widget-settings.service';

@NgModule({
    imports: [
        CustomScrollbarModule,
        TablesModule,
        ElementRulerModule,
        L10nModule,
        TextHidingModule,
        TablePaginationModule,
        PartialLoadingIndicatorModule,
        TextSearchInputModule,
        RefreshButtonModule,
        MultiselectSearchInputModule,
        DexTxHistoryWidgetSettingsComponent,
        ShortenWalletAddrPipe,
        DisplayDecimalModule,
        ValueWithDelDisplayDecimalPipe,
        WalletAvatarComponent,
        TooltipModule,
        CopyTooltipModule,
        FlashMessageModule,
        CopyTxExploreTooltipModule,
        DynAuthWidgetBodyComponent,
        NgForOf
    ],
    declarations:    [
        DexTxHistoryWidgetComponent,
        DexTxHistoryWContentComponent
    ],
    exports:         [
        DexTxHistoryWidgetComponent
    ],
    providers:       [
        DexTxHistoryWidgetSettingsService,
        BackofficeUserSessionService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_TX_HISTORY_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexTxHistoryWidgetModule {}
